module.exports = __webpack_public_path__ + "img/illustration-knowledge-sharing.f5ac00f4.svg";